interface PostPaidFormProps {
  paymentPreference: "PostPaid" | "Customer's Choice";
  setShowCheckout: (show: boolean) => void;
  setOrderMode: (mode: "Pick up" | "Delivery") => void;
  setShowPostPaidForm: (show: boolean) => void;
  submitPostPaidOrder: (customerName: string, customerPhone: string) => void;
  onCancel: () => void;
}

export const PostPaidForm: React.FC<PostPaidFormProps> = ({
  paymentPreference,
  setShowCheckout,
  setOrderMode,
  setShowPostPaidForm,
  submitPostPaidOrder,
  onCancel,
}) => {
  const payOnline = () => {
    setOrderMode("Pick up");
    setShowCheckout(true);
    setShowPostPaidForm(false);
  };

  return (
    <div className="rounded-lg bg-white p-6">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-3xl font-bold">Customer Information</h2>
        <button onClick={onCancel} className="text-5xl">
          &times;
        </button>
      </div>
      <form
        onSubmit={(e: React.FormEvent<HTMLFormElement>) => {
          e.preventDefault();
          const form = e.currentTarget;
          submitPostPaidOrder(
            (form.elements.namedItem("name") as HTMLInputElement).value,
            (form.elements.namedItem("phone") as HTMLInputElement).value,
          );
        }}
      >
        <div className="flex flex-col md:flex-row md:p-24 p-6 justify-around lg:gap-44 gap-12">
          {/* Left Column - Customer Information */}
          <div className="flex-1 space-y-4">
            <div>
              <label className="block text-gray-600 mb-1">
                Customer Name <span className="text-red-600">*</span>
              </label>
              <input
                type="text"
                id="name"
                name="name"
                required
                className="w-full rounded border border-gray-300 p-2"
                placeholder="Type name here"
              />
            </div>

            <div>
              {/* Address Not in actual use */}
              <label className="block text-gray-600 mb-1">Address </label>
              <input
                type="text"
                className="w-full rounded border border-gray-300 p-2"
                placeholder="Type address here"
              />
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-gray-600 mb-1">City </label>
                <input
                  type="text"
                  className="w-full rounded border border-gray-300 p-2"
                  placeholder="Type city here"
                />
              </div>
              <div>
                <label className="block text-gray-600 mb-1">States </label>
                <input
                  type="text"
                  className="w-full rounded border border-gray-300 p-2"
                  placeholder="Type state here"
                />
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-gray-600 mb-1">Country </label>
                <input
                  type="text"
                  className="w-full rounded border border-gray-300 p-2"
                  placeholder="Type country here"
                />
              </div>
              <div>
                <label className="block text-gray-600 mb-1">Zip Code </label>
                <input
                  type="text"
                  className="w-full rounded border border-gray-300 p-2"
                  placeholder="Type zip code here"
                />
              </div>
            </div>
          </div>

          {/* Right Column - Phone and Disclaimer */}
          <div className="flex-1">
            <div>
              <label className="block text-gray-600 mb-1">
                Phone Number <span className="text-red-600">*</span>
              </label>
              <input
                type="tel"
                id="phone"
                name="phone"
                required
                className="rounded-md border w-full border-gray-300 px-4 py-2 focus:border-red-500 focus:outline-none focus:ring-2 focus:ring-red-500"
                placeholder="Enter your phone number"
              />
              <p className="text-sm text-gray-600 mt-2">
                Please enter your 10-digit US phone number to receive order
                confirmation. By entering your number, you consent to receive
                SMS from Redbird, including marketing messages sent by Redbird
                on behalf of the merchant. You can opt out at any time by
                replying with 'STOP' or following other opt-out instructions
                provided in the messages. Message & data rates may apply.
                Message frequency varies. Text HELP for support. By proceeding,
                you agree to our{" "}
                <a
                  href="https://www.redbirdtab.com/terms-and-conditions"
                  className="underline"
                >
                  terms of service
                </a>{" "}
                and{" "}
                <a
                  href="https://www.redbirdtab.com/privacy-policy"
                  className="underline"
                >
                  privacy policy
                </a>
                .
              </p>
            </div>

            <button
              type="submit"
              className="w-full rounded bg-red-600 py-3 text-white mt-6"
            >
              Book Now
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};
